import React, { useState } from 'react';

export default function Profits() {
  const [transactionAmount, setTransactionAmount] = useState<number | string>('');
  const [category, setCategory] = useState('모델링');

  const handleTransactionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/[^0-9]/g, '');
    setTransactionAmount(value ? parseInt(value, 10) : '');
  };

  const calculateProfit = (amount: number) => {
    let firstRangeProfit = 0;
    let secondRangeProfit = 0;
    let thirdRangeProfit = 0;

    if (amount <= 500000) {
      firstRangeProfit = amount * 0.8;
    } else if (amount <= 1000000) {
      firstRangeProfit = 500000 * 0.8;
      secondRangeProfit = (amount - 500000) * 0.9;
    } else {
      firstRangeProfit = 500000 * 0.8;
      secondRangeProfit = 500000 * 0.9;
      thirdRangeProfit = (amount - 1000000) * 0.95;
    }

    return firstRangeProfit + secondRangeProfit + thirdRangeProfit;
  };

  const totalProfit = transactionAmount ? calculateProfit(Number(transactionAmount)) : 0;

  return (
    <div className="flex gap-9 w-[600px] h-[400px]">
      {/* 왼쪽 패널 */}
      <div className="text-[#111] flex-shrink-0">
        <h2 className="text-lg font-bold">전문가<br />수익금 계산기</h2>
      </div>

      {/* 오른쪽 계산기 */}
      <div className="bg-white w-full">
        <div className="mb-4">
          <label className="block text-gray-700 mb-2">카테고리</label>
          <select
            className="w-full border border-gray-300 rounded-lg p-2"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            <option value="모델링">모델링</option>
            <option value="건축">건축</option>
            <option value="엔티티">엔티티</option>
            <option value="픽셀">픽셀</option>
            <option value="무료">무료</option>
            <option value="스크립트">스크립트</option>
            <option value="스킨">스킨</option>
            <option value="스킬">스킬</option>
            <option value="플러그인">플러그인</option>
          </select>
        </div>

        <div className="mb-6">
          <label className="block text-gray-700 mb-2">거래 완료 금액</label>
          <div className="flex items-center">
            <input
              type="text"
              className="w-full border border-gray-300 rounded-lg p-2"
              placeholder="금액 입력"
              value={transactionAmount.toLocaleString('ko-KR')}
              onChange={handleTransactionChange}
            />
            <span className="ml-2">원</span>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-2">
          <table className="w-full text-left">
            <thead>
              <tr>
                <th className="font-medium text-gray-700">금액</th>
                <th className="font-medium text-gray-700">수수료</th>
                <th className="font-medium text-gray-700">전문가 수익</th>
              </tr>
            </thead>
            <tbody>
              <tr className='border-b border-b-gray-300 h-[45px]'>
                <td>1 원 ~ 500,000 원</td>
                <td>20%</td>
                <td>{transactionAmount && transactionAmount <= 500000 ? `${calculateProfit(Number(transactionAmount)).toLocaleString('ko-KR')} 원` : '80,000 원'}</td>
              </tr>
              <tr className='border-b border-b-gray-300 h-[45px]'>
                <td>500,001 원 ~ 1,000,000 원</td>
                <td>10%</td>
                <td>{transactionAmount && transactionAmount > 500000 && transactionAmount <= 1000000 ? `${calculateProfit(Number(transactionAmount)).toLocaleString('ko-KR')} 원` : '0 원'}</td>
              </tr>
              <tr className='border-b border-b-gray-300 h-[45px]'>
                <td>1,000,001 원 ~</td>
                <td>5%</td>
                <td className="truncate max-w-[30px]"> {/* 금액이 들어가는 td */}
                {transactionAmount && transactionAmount > 1000000 ? `${calculateProfit(Number(transactionAmount)).toLocaleString('ko-KR')} 원` : '0 원'}                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className='flex justify-between mt-4'>
          <span className=" text-[#111] text-sm font-medium">
            전문가 총 수익
          </span>
          <span className=' text-red-600 text-sm font-bold'>{totalProfit.toLocaleString('ko-KR')} 원</span>
        </div>

      </div>
    </div>
  );
}
